import React from 'react'
import {
  ModeSwitchDropdown as LiveViewModeSwitchDropdown,
  ScanTimer,
  SettingsDropdown as LiveViewDropdown,
  Toolbar,
} from '@plickers/now-player-library/chrome'
import { analyticsNowPlayingOpenDropdown } from '../../utils/analytics/analyticsNowPlayingOpenDropdown'
import { analyticsUpdateNowPlayingSetting } from '../../utils/analytics/analyticsUpdateNowPlayingSetting'

// Toolbar at the top on live view with settings and mode switch dropdowns, minimise and close butttons etc
// The markup is the shared library's Toolbar; this wrapper keeps the state it does not own
// (which dropdown is open) and supplies the settings, mode switch and hybrid scan timer slots.
class LiveViewToolBar extends React.Component {
  constructor() {
    super()
    this.onDropdownOpen = this.onDropdownOpen.bind(this)
    this.state = {
      settingsDropdownOpen: false,
      modeSwitchDropdownOpen: false,
    }
  }

  delayedOnDropdownClose(dropdown) {
    setTimeout(() => { // Wait for animation to finish before set state
      if (dropdown === 'settings') {
        this.setState({ settingsDropdownOpen: false })
      } else if (dropdown === 'modeSwitch') {
        this.setState({ modeSwitchDropdownOpen: false })
      }
    }, 200)
  }

  onDropdownOpen(dropdown) { // dropdown= studentList/displayOptions/modeSwitch
    if (dropdown === 'modeSwitch') {
      this.setState({ modeSwitchDropdownOpen: true })
    } else {
      this.setState({ settingsDropdownOpen: true })
    }
    analyticsNowPlayingOpenDropdown(dropdown)
  }

  render() {
    const {
      minimiseLiveView,
      section,
      sectionDataOwner,
      stopLiveView,
      isEmptyState,
      toolBarHeight,
      nowPlayingMode,
    } = this.props
    const { settingsDropdownOpen, modeSwitchDropdownOpen } = this.state
    const dropdownOpen = settingsDropdownOpen || modeSwitchDropdownOpen
    return (
      <Toolbar
        minimiseLiveView={minimiseLiveView}
        section={section}
        sectionDataOwner={sectionDataOwner}
        stopLiveView={stopLiveView}
        isEmptyState={isEmptyState}
        toolBarHeight={toolBarHeight}
        nowPlayingMode={nowPlayingMode}
        dropdownOpen={dropdownOpen}
        scanTimer={(
          <ScanTimer
            poll={this.props.poll}
            countdownEndsAt={this.props.countdownEndsAt}
            cancelCountdown={this.props.cancelCountdown}
            incrementCountdown={this.props.incrementCountdown}
            isScanning={this.props.questionStage === 'scan'}
            handleCountdownEnd={this.props.handleCountdownEnd}
            setCountdownSeconds={this.props.setCountdownSeconds}
            countDownTimerStartSecondsLength={this.props.countDownTimerStartSecondsLength}
          />
        )}
        settingsDropdown={(
          <LiveViewDropdown
            onDropdownOpen={(dropdown) => { this.onDropdownOpen(dropdown) }}
            onDropdownClose={() => { this.delayedOnDropdownClose('settings') }}
            onSettingTracked={analyticsUpdateNowPlayingSetting}
          />
        )}
        modeSwitchDropdown={(
          <LiveViewModeSwitchDropdown
            section={section}
            switchNowPlayingMode={this.props.switchNowPlayingMode}
            nowPlayingMode={nowPlayingMode}
            onlineStudentsCount={this.props.onlineStudentsCount}
            onDropdownOpen={() => { this.onDropdownOpen('modeSwitch') }}
            onDropdownClose={() => { this.delayedOnDropdownClose('modeSwitch') }}
          />
        )}
      />
    )
  }
}

export default LiveViewToolBar
